module.exports = __webpack_public_path__ + "static/media/schedule-icon.9d921f3f.svg";